'use strict';

class MarketplacePlace {

    constructor(element, limits, index) {
        this.element = element;
        this.limits = limits;
        this.index = index || 0;
        this.lengthInput = element.find('.length');
        this.widthInput = element.find('.width');
        this.heightInput = element.find('.height');
        this.volumeInput = element.find('.volume');
        this.weightInput = element.find('.weight');
        this.countInput = element.find('.count_place');
        this.indicators = element.find('.progress-indicators');

        const servicesContainer = element.find('.additional-services');
        this.servicesContainer = servicesContainer.length > 0 ? servicesContainer : null;

        if (this.servicesContainer) {
            this.initServices();
        }
    }

    getLength() {
        return parseFloat(this.lengthInput.val()) || 0;
    }


    getWidth() {
        return parseFloat(this.widthInput.val()) || 0;
    }

    getHeight() {
        return parseFloat(this.heightInput.val()) || 0;
    }

    getWeight() {
        return parseFloat(this.weightInput.val()) || 0;
    }

    getCount() {
        return parseInt(this.countInput.val()) || 1;
    }

    calculateVolume() {
        const volume = (this.getLength() * this.getWidth() * this.getHeight() / 1000000).toFixed(6);
        this.volumeInput.val(volume);
        return parseFloat(volume);
    }

    initServices() {

        if (!this.servicesContainer || this.servicesContainer.length === 0) {
            console.warn(`Контейнер с услугами не найден для места с индексом ${this.index}`);
            return;
        }

        const collapseButton = this.servicesContainer.find('[data-target]');
        if (collapseButton.length > 0) {
            collapseButton.attr('data-target', `#services-collapse-${this.index}`);
            collapseButton.attr('aria-controls', `services-collapse-${this.index}`);
        }

        const collapseDiv = this.servicesContainer.find('.collapse');
        if (collapseDiv.length > 0) {
            collapseDiv.attr('id', `services-collapse-${this.index}`);
        }

        this.servicesContainer.find('.service-checkbox').each((i, checkbox) => {
            const $checkbox = $(checkbox);
            const serviceCode = $checkbox.val();

            if (serviceCode) {
                const newId = `service-${serviceCode}-${this.index}`;

                $checkbox.attr('id', newId);
                $checkbox.attr('name', `places[${this.index}][services][]`);

                const label = $checkbox.next('label');
                if (label.length > 0) {
                    label.attr('for', newId);
                }
            }
        });
    }
    getSelectedServices() {
        const service = [];
        this.servicesContainer.find('.service-checkbox:checked').each(function() {
            service.push($(this).val());
        });
        return service;
    }

    getData() {
        const data = {
            length: this.getLength(),
            width: this.getWidth(),
            height: this.getHeight(),
            weight: this.getWeight(),
            count_place: this.getCount(),
            volume: this.calculateVolume()
        };

        const service = this.getSelectedServices();
        if (service.length > 0) {
            data.service = service;
        }

        return data;
    }

    validateDimensions(tariffType) {
        const limits = this.limits[tariffType];
        return this.getLength() <= limits.maxL &&
            this.getWidth() <= limits.maxW &&
            this.getHeight() <= limits.maxH;
    }

    isValidForBoxTariff() {
        const volume = this.calculateVolume();
        const weight = this.getWeight();
        const limits = this.limits.box;

        return volume >= limits.minVolume &&
            volume <= limits.maxVolume &&
            weight >= limits.minWeight &&
            weight <= limits.maxWeight &&
            this.validateDimensions('box');
    }

    isValidForBigTariff() {
        const volume = this.calculateVolume();
        const weight = this.getWeight();
        const boxLimits = this.limits.box;
        const bigLimits = this.limits.big;

        return (volume > boxLimits.maxVolume || weight > boxLimits.maxWeight) &&
            volume <= bigLimits.maxVolume &&
            weight <= bigLimits.maxWeight &&
            this.validateDimensions('big');
    }

    updateDimensionLimits(tariffType) {
        const limits = this.limits[tariffType];
        this.lengthInput.attr('max', limits.maxL)
            .attr('title', `Макс. длина: ${limits.maxL} см`);
        this.widthInput.attr('max', limits.maxW)
            .attr('title', `Макс. ширина: ${limits.maxW} см`);
        this.heightInput.attr('max', limits.maxH)
            .attr('title', `Макс. высота: ${limits.maxH} см`);
    }

   updateIndicators(tariffType) {
    const volume = this.calculateVolume();
    const weight = this.getWeight();
    const boxIndicators = this.indicators.find('.box-indicators');
    const bigIndicators = this.indicators.find('.big-indicators');
    const messageDiv = this.indicators.find('.place-message');

    this.element.removeClass('invalid-place');
    this.element.removeClass('valid-place');

   if (tariffType === 'box') {
    // Тариф "Короб"
    boxIndicators.show();
    bigIndicators.hide();

    const limits = this.limits.box;
    
    // Отдельные проверки для объема и веса
    const isVolumeValid = volume >= limits.minVolume && volume <= limits.maxVolume;
    const isWeightValid = weight >= limits.minWeight && weight <= limits.maxWeight;
    const dimensionsValid = this.validateDimensions('box');
    
    // Общая проверка (для валидации места)
    const isValidBox = isVolumeValid && isWeightValid && dimensionsValid;

    // Прогресс для объема (относительно maxVolume)
    const volumePercent = (volume / limits.maxVolume) * 100;
    // Прогресс для веса (относительно maxWeight)
    const weightPercent = (weight / limits.maxWeight) * 100;

    // Обновляем прогресс-бары с индивидуальными цветами
    this._updateProgressBar(this.indicators.find('.volume-progress'), volumePercent, isVolumeValid);
    this._updateProgressBar(this.indicators.find('.weight-progress'), weightPercent, isWeightValid);

    // Обновляем значения объема и веса
    boxIndicators.find('.volume-value').text(volume.toFixed(3) + ' м³');
    boxIndicators.find('.weight-value').text(weight + ' кг');

    // Текст для объема (первый small)
    const volumeText = boxIndicators.find('.d-flex:first-child small:first-child');
    volumeText.text('Объем места (0.001 м³ - 0.1 м³)');
    
    // Текст для веса (второй small)
    const weightText = boxIndicators.find('.d-flex:eq(1) small:first-child');
    weightText.text('Вес места (1 - 30 кг)');

    // Подсветка места
    if (isValidBox) {
        this.element.addClass('valid-place').removeClass('invalid-place');
    } else {
        this.element.addClass('invalid-place').removeClass('valid-place');
    }

    // Дополнительное сообщение
    if (messageDiv.length) {
        if (isValidBox) {
            messageDiv.html('<div class="alert alert-success py-1 px-2 small d-none">Параметры соответствуют тарифу "Короб"</div>');
        } else {
            let errorMsg = 'Параметры не соответствуют тарифу "Короб"';
            messageDiv.html(`<div class="alert alert-danger py-1 px-2 small">${errorMsg}</div>`);
        }
    }
} else {
        // Тариф "Паллет" (оставляем как есть)
        boxIndicators.hide();
        bigIndicators.show();

        const isValidBig = this.isValidForBigTariff();

        this._updateProgressBar(this.indicators.find('.params-progress'), 100, isValidBig);
        bigIndicators.find('.params-value').text(`V:${volume.toFixed(3)} м³, W:${weight} кг`);

        const bigStatusText = bigIndicators.find('.d-flex small:first-child');
        
        if (isValidBig) {
            bigStatusText.text('✓ Соответствие тарифу "Паллет"');
            bigStatusText.removeClass('text-danger').addClass('text-success');
            this.element.addClass('valid-place');
        } else {
            bigStatusText.text('✗ Не соответствует тарифу "Паллет"');
            bigStatusText.removeClass('text-success').addClass('text-danger');
            this.element.addClass('invalid-place');
        }

        if (messageDiv.length) {
            messageDiv.html(isValidBig ? 
                '<div class="alert alert-success py-1 px-2 small d-none">Параметры соответствуют тарифу "Паллет"</div>' :
                '<div class="alert alert-danger py-1 px-2 small">Параметры не соответствуют тарифу "Паллет"</div>'
            );
        }
    }
}


    _updateProgressBar(bar, percent, isValid) {
        bar.css('width', Math.min(100, percent) + '%')
            .removeClass('bg-success bg-danger')
            .addClass(isValid ? 'bg-success' : 'bg-danger');
    }
}


